import {
  collection,
  doc,
  type Firestore,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import {
  convertDocumentSnapshotToModel,
  modelItemStream,
} from '../../firestore-mobx/stream'
import type { FirebaseRepository } from '../../models/FirebaseRepository'
import { SettingsLti } from '../../models/SettingsLti'
import type { FirestoreSettingsLti } from './schema'
import { schema } from './schema'
import { getDocWithError, setDocWithError } from '../../firestore-mobx/fetch'

export * from './schema'

const converter: FirestoreDataConverter<FirestoreSettingsLti> = {
  toFirestore: (settings: FirestoreSettingsLti) => settings,
  fromFirestore: (snapshot: QueryDocumentSnapshot) => {
    return schema.parse(snapshot.data())
  },
}

export const getDocRef = (firestore: Firestore) => {
  return doc(collection(firestore, 'settings').withConverter(converter), 'lti')
}

export const fetchSettingsLti = async (repository: FirebaseRepository) => {
  const docRef = getDocRef(repository.firestore)

  const docSnapshot = await getDocWithError(docRef, 'FetchSettingsLtiError')

  return convertDocumentSnapshotToModel(repository, docSnapshot, SettingsLti)
}

export const getSettingsLti = (repository: FirebaseRepository) => {
  const docRef = getDocRef(repository.firestore)

  return modelItemStream(repository, docRef, SettingsLti)
}

export const updateSettingsLti = async (
  repository: FirebaseRepository,
  data: Partial<FirestoreSettingsLti>
) => {
  const docRef = getDocRef(repository.firestore)

  return setDocWithError(docRef, data, {
    merge: true,
    errorName: 'UpdateSettingsLtiError',
  })
}
